import UserPng1 from './user/img-customer-service-01.png';
import UserPng2 from './user/img-customer-service-02.png';
import UserPng3 from './user/img-customer-service-03.png';
import UserPng4 from './user/img-customer-service-04.png';
import UserPng5 from './user/img-customer-service-05.png';
import UserPng6 from './user/img-customer-service-06.png';
import AIUserPng1 from './user/img-ai-customer-service-01.png';
import UserClientSvg from './user/img-user-default.svg';
import UserClientBlueSvg from './user/img-user-blue.svg';
import UserClientRedSvg from './user/img-user-red.svg';
import UserRobotSvg from './user/img-customer-service-robot.svg';
import ClientWaitingSvg from './user/img-cs-big.svg';
import NoticeImgSvg from './ic-16-warning.svg';
import FileSvg from './ic-28-type-file.svg';
import AudioSvg from './ic-28-type-music.svg';
import VideoSvg from './ic-28-type-video.svg';
import ScreenshotSvg from './ic-screenshot.svg';
import System404Svg from './img-404.svg';
import SystemLoadingSvg from './img-loading.svg';
import SystemNetworkSvg from './img-network.svg';
import SystemBugFixingSvg from './img-bug-fixing.svg';
import SystemConversationOverSvg from './img-conversation-over.svg';
import TransferSvg from './ic-transfer-b.svg';
import AddSvg from './ic-add.svg';
import PlusSvg from './ic-18-plus.svg';
import CheckSvg from './ic-check.svg';
import DragSvg from './ic-drop.svg';
import ArrowOutSvg from './ic-arrow-out-w.svg';
import ArrowLeftSvg from './ic-16-arrow-left.svg';
import ArrowRightSvg from './ic-16-arrow-right.svg';
import FileImgSvg from './ic-28-type-file.svg';
import VideoImgSvg from './ic-28-type-video.svg';
import AudioImgSvg from './ic-28-type-music.svg';
import DownloadSvg from './ic-download.svg';
import BlueDownloadSvg from './ic-blue-download.svg';
import GrayDownloadSvg from './ic-gray-download.svg';
import LinkSvg from './ic-18-link.svg';
import LoadingSvg from './ic-18-loading.svg';
import BtnToolbarDownloadNormalSvg from './btn-toolbar-download-normal.svg';
import BtnToolbarMirrorNormalSvg from './btn-toolbar-mirror-normal.svg';
import BtnToolbarCloseNormalSvg from './btn-toolbar-close-normal.svg';
import BtnToolbarRotateLeftNormalSvg from './btn-toolbar-rotate-left-normal.svg';
import BtnToolbarRotateRightNormalSvg from './btn-toolbar-rotate-right-normal.svg';
import BtnToolbarZoomInNormalSvg from './btn-toolbar-zoom-in-normal.svg';
import BtnToolbarZoomOutNormalSvg from './btn-toolbar-zoom-out-normal.svg';
import UploadSvg from './ic-upload.svg';
import EmojiSvg from './ic-emoji.svg';
import LocationSvg from './ic-location.svg';
import BarchartSvg from './ic-18-barchart-normal.svg';
import ClockSvg from './ic-18-clock-normal.svg';
import ClockBlackSvg from './ic-clock-b.svg';
import ClockWhiteSvg from './ic-clock-w.svg';
import InfoSvg from './ic-18-info-normal.svg';
import InfoFillSvg from './ic-14-info-fill.svg';
import AnalyticsSvg from './ic-analytics.svg';
import SettingSvg from './ic-18-settings-pressed.svg';
import SliderSvg from './ic-18-sliders-normal.svg';
import MessageWhiteSvg from './ic-message-w.svg';
import EmptyMessageSvg from './img-empty-message.svg';
import CalendarSvg from './ic-calendar.svg';
import EndSvg from './ic-28-end.svg';
import AllUserSvg from './ic-03.svg';
import DocumentSvg from './ic-document.svg';
import TranslateSvg from './ic-translate.svg';
import TrackBlackSvg from './ic-track-b.svg';
import TrackOrangeSvg from './ic-track-orange.svg';
import PlayBlueSvg from './ic-play-b.svg';
import QuestionSvg from './question.svg';
import InfoWhiteSvg from './ic-info.svg';
import IcReloadPng from './ic-reload.png';
import IcImportant from './ic-important.svg';
import IcImportantBlack from './ic-important-b.svg';
import IcResume from './ic-resume.svg';
import IcQuoteSvg from './ic-quote.svg';
import IcCopySvg from './ic-copy.svg';
import IcCloseSvg from './ic-28-close.svg';
import IcRevokeSvg from './ic-revoke.svg';
import SalmonInfoSvg from './ic-salmon-info.svg';
import AISvg from './ic-18-ai.svg';
import HamburgerSvg from './ic-hamburger.svg';
import IcCloseGraySvg from './ic-close-gray.svg';
import EmptyImageSvg from './img-empty-photo.svg';
import EmptyPhotoSvg from './empty-photo.svg';
import IcEditSvg from './ic-16-edit.svg';
import InfoRedSvg from './ic-18-info-red.svg';
import IcServicePng from './ic-service.png';
import IcOperatePng from './ic-operate.png';
import IcGemSvg from './ic-gem.svg';
import IcGemBlackSvg from './ic-gem-b.svg';
import BWCsLeaveSvg from './bw-cs-leave.svg';
import BWMgLeaveSvg from './bw-mg-leave.svg';
import NextTagSvg from './ic-next-tag.svg';
import CustomerJourneySvg from './ic-customer-journey.svg';
import IcLanguageSvg from './ic-language.svg';
import IcDeleteSvg from './ic-delete.svg';
import IcPreviewSvg from './ic-24-preview.svg';
import IcImageSvg from './ic-48-image.svg';
import IcLoadingPng from './ic-loading.png';
import ImgLoadingGif from './img-loading-gif.gif';
import IcEyeCloseSvg from './ic-eye-close.svg';
import IcEyeOpenSvg from './ic-eye-open.svg';
import IcAdd40Svg from './ic-40-add.svg';
import IcDeleteCirclePng from './ic-delete-circle.png';
import InterceptAlertSvg from './ic-intercept-alert.svg';
import InterceptNextSvg from './ic-intercept-next.svg';
import ReloadSvg from './ic-reload.svg';
import IcShieldSvg from './ic-16-shield.svg';
import IcMessageSvg from './ic-16-message.svg';
import IcAlertSvg from './ic-16-alert.svg';
import IcQuestionSvg from './ic-16-question.svg';
import IcIdeaSvg from './ic-16-idea.svg';
import IcEditPenSvg from './ic-16-edit-pen.svg';

// Webp
import HotTagWebp from './theme-images/ic-hot/icon-28@2x.webp';
import NewTagWebp from './theme-images/ic-new/icon-28@2x.webp';

export const CSAvatarMap = {
	1: UserPng1,
	2: UserPng2,
	3: UserPng3,
	4: UserPng4,
	5: UserPng5,
	6: UserPng6,
};

export const AICSAvatarMap = {
	1: AIUserPng1,
};

export {
	NoticeImgSvg,
	FileSvg,
	AudioSvg,
	VideoSvg,
	ScreenshotSvg,
	System404Svg,
	SystemLoadingSvg,
	SystemNetworkSvg,
	SystemBugFixingSvg,
	SystemConversationOverSvg,
	TransferSvg,
	AddSvg,
	PlusSvg,
	CheckSvg,
	DragSvg,
	ArrowOutSvg,
	ArrowLeftSvg,
	ArrowRightSvg,
	FileImgSvg,
	VideoImgSvg,
	AudioImgSvg,
	DownloadSvg,
	BlueDownloadSvg,
	GrayDownloadSvg,
	LinkSvg,
	LoadingSvg,
	BtnToolbarDownloadNormalSvg,
	BtnToolbarMirrorNormalSvg,
	BtnToolbarCloseNormalSvg,
	BtnToolbarRotateLeftNormalSvg,
	BtnToolbarRotateRightNormalSvg,
	BtnToolbarZoomInNormalSvg,
	BtnToolbarZoomOutNormalSvg,
	UploadSvg,
	EmojiSvg,
	LocationSvg,
	BarchartSvg,
	ClockSvg,
	ClockBlackSvg,
	ClockWhiteSvg,
	InfoSvg,
	InfoFillSvg,
	AnalyticsSvg,
	SettingSvg,
	SliderSvg,
	UserClientSvg,
	UserClientBlueSvg,
	UserClientRedSvg,
	UserRobotSvg,
	MessageWhiteSvg,
	ClientWaitingSvg,
	EmptyMessageSvg,
	CalendarSvg,
	EndSvg,
	AllUserSvg,
	DocumentSvg,
	TranslateSvg,
	TrackBlackSvg,
	TrackOrangeSvg,
	PlayBlueSvg,
	QuestionSvg,
	InfoWhiteSvg,
	IcImportant,
	IcImportantBlack,
	IcResume,
	IcQuoteSvg,
	IcCloseSvg,
	IcCopySvg,
	IcRevokeSvg,
	SalmonInfoSvg,
	AISvg,
	HamburgerSvg,
	IcCloseGraySvg,
	IcEditSvg,
	InfoRedSvg,
	EmptyImageSvg,
	EmptyPhotoSvg,
	IcGemSvg,
	IcGemBlackSvg,
	BWCsLeaveSvg,
	BWMgLeaveSvg,
	NextTagSvg,
	CustomerJourneySvg,
	IcLanguageSvg,
	IcDeleteSvg,
	IcPreviewSvg,
	IcImageSvg,
	IcEyeCloseSvg,
	IcEyeOpenSvg,
	IcAdd40Svg,
	InterceptAlertSvg,
	InterceptNextSvg,
	ReloadSvg,
	IcShieldSvg,
	IcMessageSvg,
	IcAlertSvg,
	IcQuestionSvg,
	IcIdeaSvg,
	IcEditPenSvg,

	// Image png
	IcReloadPng,
	IcServicePng,
	IcOperatePng,
	IcLoadingPng,
	ImgLoadingGif,
	IcDeleteCirclePng,

	// Webp
	HotTagWebp,
	NewTagWebp,
};
